import styled, { css, keyframes } from 'styled-components';
import detail from './components/chartImage/img/detail.png';


const fadeIn = keyframes`
	0% {	opacity: 0;}
	50% {	opacity: 0;}
	100% {	opacity: 1;}
`;

interface Props {
	showModalDiscount: boolean;
}

export const PaymentModalDiscount = styled.div<Pick<Props, 'showModalDiscount'>>`
	border-radius: 24px 24px 0 0;
	padding-top: 48px;
	background-color: #F2EDE1;
	max-width: 470px;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  z-index: 110;
	margin-left: auto;
	margin-right: auto;
`;

export const CloseButton = styled.button`
	width: 40px;
	height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 12px;
	background: none;

	img {
		width: 16px;
		min-width: 16px;
	}
`;

export const FlexContainer = styled.div`
	display: flex;
	width: 100%;
`;

export const Margined = styled.div`
	margin: 0 0px;
	height: 100%;
	display: flex;
	flex-direction: column;
`;

export const Container = styled.section`
	display: flex;
	flex-direction: column;
	position: fixed;
	left: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	overflow: overlay;
	// transform: translateY(60%);
`;

export const CloseArea = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: -2;
	background: #e0dfe7;
	transition: opacity 0.25s ease-out;
`;

export const ModalWindowContainer = styled.div`
	margin: 20px auto auto;
	padding-bottom: 60px;
	width: 100%;
	max-width: 470px;
	height: 200vh;
	position: relative;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
	background-color: white;
	z-index: 2;
`;

export const CloseButtonContainer = styled.div`
	position: absolute;
	top: 16px;
	right: 21px;
`;

export const Title = styled.h2`
	color: #231E19;
	text-align: center;
	font-family: var(--ed-font-rounded, ui-rounded, "SF Pro Rounded", Nunito, "SF Pro Text", -apple-system, BlinkMacSystemFont, "Roboto", sans-serif);
	font-size: 19px;
	font-weight: 700;
	line-height: 24px;
	letter-spacing: 0.076px;
	padding: 0 20px;
`;

export const Wrapper = styled.div`
	padding-bottom: 16px;
	width: 100%;
	border-radius: 8px;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

export const ChartWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	animation: ${fadeIn} 0.2s 0.1s ease both;
`;

export const ChartContainer = styled.div`
	position: relative;
	height: auto;
	width: 100%;
`;

export const Description = styled.div`
	margin-top: -10px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 36px;

	p {
		font-family: var(--ed-font-rounded, ui-rounded, "SF Pro Rounded", Nunito, "SF Pro Text", -apple-system, BlinkMacSystemFont, "Roboto", sans-serif);
		font-size: 14.045px;
		font-weight: 700;
		line-height: 16.051px;
		letter-spacing: 0.056px;
	}
	
	p:nth-child(1) {
		color: #7B766F;
	}

	p:nth-child(2) {
		color: #00A36F;
	}
`;

export const Bubble2 = styled.div`
	border-radius: 21.067px;
	background: linear-gradient(251deg, #00A36F 16.17%, #C3D300 168.85%, #FF8D00 321.52%), #00A470;
	color: #FFFBF1;
	font-family: var(--ed-font-rounded, ui-rounded, "SF Pro Rounded", Nunito, "SF Pro Text", -apple-system, BlinkMacSystemFont, "Roboto", sans-serif);
	font-size: 10.032px;
	font-weight: 700;
	line-height: 16.051px;
	letter-spacing: 0.04px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 4px 6px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	padding: 4px 10px;
	position: absolute;
	top: 27px;
	right: 36px;
`;

export const Bubble3 = styled.div`
	border-radius: 21.067px;
	background: linear-gradient(0deg, #F9C885 0%, #F9C885 100%), #00A470;
	color: #FFFBF1;
	font-family: var(--ed-font-rounded, ui-rounded, "SF Pro Rounded", Nunito, "SF Pro Text", -apple-system, BlinkMacSystemFont, "Roboto", sans-serif);
	font-size: 10.032px;
	font-weight: 700;
	line-height: 16.051px;
	letter-spacing: 0.04px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 4px 10px;
	white-space: nowrap;
	position: absolute;
	top: 31vw;
	right: 36px;

	@media(min-width: 470px) {
		top: 143px;
	}
`;

export const Offer = styled.div`
	width: 100%;
	padding: 20px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	border-radius: 32px 32px 0px 0px;
	background: #FFFBF1;
	box-shadow: 0px 0px 40px 0px rgba(153, 148, 138, 0.20);
	margin-top: auto;

	h4 {
		color: #231E19;
		text-align: center;
		font-family: var(--ed-font-rounded, ui-rounded, "SF Pro Rounded", Nunito, "SF Pro Text", -apple-system, BlinkMacSystemFont, "Roboto", sans-serif);
		font-size: 28px;
		font-weight: 700;
		line-height: 34px;
		letter-spacing: -0.4px;
		margin-bottom: 8px;
	}
`;

export const OfferImg = styled.img`
	width: 202px;
	margin-bottom: 10px;
`;

export const OfferText = styled.p`
	color: #7B766F;
	text-align: center;
	font-size: 17px;
	font-weight: 400;
	line-height: 22px;
	letter-spacing: 0.051px;
`;

export const ButtonWrapper = styled.div`
	margin-top: 20px;
	width: 100%;

	p {
		padding: 0 40px
	}
`;
